{
  "ACTION": {
    "CLEAR_FILTER": "Wissen",
    "CONTINUE": "Doorgaan",
    "EDIT": "Wijzigen",
    "SEND": "Verzenden",
    "VALIDATE": "Bevestigen"
  },
  "ARIA": {
    "MENU": "Hoofdmenu"
  },
  "COMPONENT": {
    "AGENDA-MAGASIN-TUNNEL": {
      "I_WANT_TO_TAKE_MY_APPOINTMENT": "Ik wil mijn afspraak",
      "IN_STORE": "In de winkel",
      "REMOTELY": "Via video"
    },
    "AVIS-GOOGLE": {
      "OUT_OF": "op",
      "REVIEWS": "Reviews"
    },
    "AVIS-GOOGLE-DETAILS": {
      "AVERAGE_RATING_DISCLAIMER": "Deze score is berekend op basis van de <strong>{{nbReviews}} Google-reviews*</strong> die onze klanten in onze verschillende winkels in heel Frankrijk hebben achtergelaten na hun ervaring met SoCoo'c. *Onze Google-reviews zijn niet geverifieerd.",
      "AVERAGE_RATING_DISCLAIMER_STORE": "Deze score is berekend op basis van de <strong>{{nbReviews}} Google-reviews*</strong> die onze klanten in onze winkel hebben achtergelaten na hun ervaring met SoCoo'c. *Onze Google-reviews zijn niet geverifieerd.",
      "REVIEWS_STAR": "Reviews met {{count}} ster:",
      "REVIEWS_STARS": "Reviews met {{count}} sterren:",
      "SEE_MORE_REVIEWS": "Meer reviews bekijken",
      "SORT_BY_HIGHEST_TO_LOWEST_RATED": "Van hoogste naar laagste score:"
    },
    "CARTE-OPPORTUNITES": {
      "OPENING_OPPORTUNITIES": "Openingsmogelijkheden",
      "OVERSEAS_OPPORTUNITIES": "Onze mogelijkheden in de overzeese gebieden",
      "STORES_OPEN": "Geopende winkels"
    },
    "CONFIRMATION-RDV": {
      "THANK_YOU_RESPONSE": "Bedankt voor uw antwoord"
    },
    "CONFIRMATION-RDV-ESPACE-CLIENT": {
      "ADD_TO_CALENDAR": "Toevoegen aan mijn agenda",
      "CALENDAR_EVENT_TITLE": "Afspraak {{store}}",
      "IMPEDIMENT_TITLE": "Iets tussengekomen?",
      "IMPEDIMENT_TEXT": "Laat het ons weten, zodat we de koffie niet te vroeg zetten ;) Dat kan heel eenvoudig in uw SoCoo'c-klantenzone: u kunt uw afspraak wijzigen of annuleren.",
      "CREATE_ACCOUNT": "Ik maak mijn SoCoo'c-account aan",
      "LOGIN": "Ik meld me aan",
      "MY_ACCOUNT": "Naar mijn SoCoo'c-account"
    },
    "CONTENU-ARTICLE": {
      "MINUTE": "{{count}} minuut",
      "MINUTES": "{{count}} minuten",
      "READING_TIME_LABEL": "Leestijd:"
    },
    "ENCART-INFOS-MAGASIN": {
      "CLOSED": "Gesloten",
      "EXCEPTIONAL_CLOSURE": "Uitzonderlijke sluiting",
      "EXCEPTIONAL_OPENING": "Uitzonderlijke opening",
      "SHOW_ALL_REVIEWS": "Alle reviews bekijken"
    },
    "ESTIMATEUR-BUDGET-DETAIL-PRIX": {
      "CALCULATING_CURRENT_PRICE": "Prijs wordt berekend",
      "DELIVERY_INCLUDED": "Levering inbegrepen",
      "PRICE_BREAKDOWN_DETAIL": "Prijsdetail",
      "STARTING_FROM_PER_MONTH": "Vanaf {{price}}/maand"
    },
    "ESTIMATEUR-BUDGET-SELECTION": {
      "ESTIMATION_INDEX": "Raming {{ index }}",
      "HOUSEHOLD_APPLIANCE": "Huishoudtoestellen",
      "MY_ESTIMATIONS": "Mijn ramingen",
      "MY_SELECTION": "Mijn selectie",
      "PRICE_RANGE": "Tussen {{ minPrice }} en {{ maxPrice }}",
      "REQUEST_NEW_ESTIMATE": "Nieuwe raming",
      "SEND_BY_EMAIL": "Per e-mail versturen"
    },
    "ESTIMATEUR-ETAPE": {
      "HEADER": {
        "APPLIANCES_AND_PLUMBING_LABEL": "Toestellen en sanitair",
        "DELIVERY_AND_INSTALLATION_LABEL": "Levering en plaatsing",
        "FURNITURE_LABEL": "Meubelen",
        "PRICE_ESTIMATE_LABEL": "Raming"
      },
      "I_DONT_NEED_ANYTHING": "Ik heb niets nodig"
    },
    "FORMULAIRE-CATALOGUE": {
      "CATALOG_SENT_TO_EMAIL": "Uw catalogus is per e-mail verstuurd naar {{ email }}.",
      "CATALOG_WAITING_IN_MAILBOX": "Uw catalogus wacht op u in uw mailbox.",
      "CHECK_SPAM_IF_NOT_RECEIVED": "Hebt u hem na enkele minuten nog steeds niet ontvangen? Kijk dan in uw spam.",
      "DOWNLOAD_CATALOG": "Catalogus downloaden",
      "FORM_ERROR": "Fout bij het verzenden van het formulier.",
      "LABEL_EMAIL": "Mijn e-mailadres:"
    },
    "FORMULAIRE-CONTACT-B2B": {
      "DEVELOPER_SECTION_DESCRIPTION": "Selecteer de gewenste vestigingsregio om te ontdekken welke netwerkontwikkelaar uw aanspreekpunt is",
      "DEVELOPER_SECTION_TITLE": "Ons ontwikkelingsteam staat voor u klaar!",
      "LABEL_AREA": "Vestigingsregio:",
      "LABEL_EMAIL": "Mijn e-mailadres:",
      "LABEL_FIRST_NAME": "Mijn voornaam:",
      "LABEL_LAST_NAME": "Mijn naam:",
      "LABEL_MESSAGE": "Een berichtje voor onze netwerkontwikkelaars:",
      "LABEL_PHONE": "Mijn telefoonnummer:",
      "MESSAGE_CONFIRMATION_RESPONSE_SOON": "Uw bericht is doorgestuurd naar onze teams, we antwoorden u zo snel mogelijk.",
      "MESSAGE_HELPER_TEXT": "Geef ons wat meer informatie over uw project: gewenste vestigingsplaats(en), uw ervaring, ..."
    },
    "FORMULAIRE-RDV": {
      "FORM_PLACEHOLDER_MESSAGE": "Hebt u al een van onze Kitcheners ontmoet, of wilt u graag een bepaalde Kitchener ontmoeten?\nHebt u een keukenproject? Of hebt u informatie nodig?",
      "LABEL_APPOINTMENT": "Uw afspraak:",
      "LABEL_APPOINTMENT_DATETIME": "om",
      "LABEL_CUSTOM_MESSAGE": "Een persoonlijk berichtje?",
      "LABEL_STORE_LOCATION": "In uw winkel ",
      "LABEL_WHEN": "Wanneer",
      "LABEL_WHERE": "Waar",
      "VIDEO_APPOINTMENT_WITH_STORE": "Via video met uw winkel"
    },
    "HERO-MODELE": {
      "ALL_OUR_FINISHES": "Al onze afwerkingen",
      "KITCHEN_LAYOUT_WITH_SURFACE": "Keuken {{type}} van {{surface}}"
    },
    "HERO-SLIDER": {
      "VIRTUAL_TOUR": "Virtuele rondleiding"
    },
    "KITCHEN-MODEL-CARD": {
      "SEE_THIS_KITCHEN": "Deze keuken bekijken"
    },
    "LISTING-AUTRES-FACADES": {
      "OTHER_FRONTS": "De andere fronten"
    },
    "LISTING-COIN-REPAS": {
      "FROM": "Vanaf:",
      "PER_UNIT": "per stuk"
    },
    "LISTING-FACADES": {
      "NO_RESULTS": "Geen resultaten voor dit type front."
    },
    "LISTING-MAGASIN": {
      "SEE_THIS_STORE": "Deze winkel bekijken"
    },
    "LISTING-MEUBLES-IMAGE-NOM-DESCRIPTION": {
      "AVAILABLE_HEIGHTS": "Beschikbare hoogtes",
      "AVAILABLE_WIDTHS": "Beschikbare breedtes"
    },
    "LISTING-PACK-PRODUITS": {
      "FOR_THE_SET": "Het geheel",
      "INSTEAD_OF": "In plaats van:"
    },
    "LISTING-TEMOIGNAGES": {
      "SEE_MORE_TESTIMONIES": "Meer getuigenissen bekijken"
    },
    "MAP-POPIN": {
      "WANT_TO_KNOW_MORE_OPPORTUNITY": "Wilt u meer weten over deze opportuniteit?"
    },
    "MENU-BLOG": {
      "THE_BLOG": "De blog",
      "THE_SECTIONS": "De rubrieken"
    },
    "MENU-TUNNEL": {
      "CONTACT_DETAILS": "Contactgegevens",
      "DAY_AND_TIME": "Dag en uur",
      "STORE": "Winkel"
    },
    "POPIN-ESTIMATION-EMAIL": {
      "ALL_GOOD": "Alles in orde!",
      "ESTIMATE_SENT_CONFIRMATION": "<p>Uw raming is per e-mail verstuurd naar {{email}}.</p><p>Hebt u ze na enkele minuten nog steeds niet ontvangen? Kijk dan in uw spam.</p>",
      "MY_EMAIL_ADDRESS": "Mijn e-mailadres",
      "PRIVACY_POLICY_REMINDER": "Raadpleeg ons <strong><a target=\"_blank\"  class=\"cursor-pointer\" href=\"{{privacyPolicyUrl}}\">privacybeleid</a></strong> om te weten hoe wij de gegevens gebruiken die via dit formulier worden verzameld en om uw rechten op uw persoonsgegevens uit te oefenen, met name inzake inzage en verwijdering.",
      "SEND_ESTIMATE": "Raming versturen",
      "SEND_KITCHEN_ESTIMATE_BY_EMAIL": "De raming van mijn keuken per e-mail versturen"
    },
    "POPIN-PRICE-DETAIL": {
      "LOADING_PRICE_DETAILS": "Prijsdetail wordt geladen"
    },
    "POPIN-REALISATIONS-CLIENTS": {
      "CREATED_BY": "Gerealiseerd door:",
      "NEXT_KITCHEN": "Volgende keuken",
      "PREVIOUS_KITCHEN": "Vorige keuken"
    },
    "SEARCH": {
      "LABEL_MY_CITY": "Mijn gemeente"
    },
    "STORE-LOCATOR": {
      "BOOK_APPOINTMENT": "Afspraak maken",
      "DISTANCE_IN_KM": "Op {{km}} km",
      "PLACEHOLDER_CITY_OR_POSTAL_CODE": "Gemeente of postcode",
      "SELECT_THIS_STORE": "Deze winkel kiezen",
      "VIDEO_APPOINTMENT_AVAILABLE": "Videoafspraak mogelijk"
    },
    "TEXTE-SEO": {
      "SEE_LESS": "Minder tonen",
      "SEE_MORE": "Meer tonen"
    },
    "TITRE-FILTRES-MODELES": {
      "BUDGET_PLACEHOLDER": "Budget",
      "CHOOSE_ACTION": "Ik kies",
      "KITCHEN_FRONTS_PLACEHOLDER": "de fronten",
      "KITCHEN_LAYOUT": "mijn opstelling",
      "LAYOUT_PLACEHOLDER": "Opstelling",
      "OUR_SELECTION": "Onze selectie",
      "PRICE_ASCENDING": "Van goedkoop naar duur",
      "PRICE_DESCENDING": "Van duur naar goedkoop",
      "PRICE_LESS_THAN": "Minder dan {{amount}} €",
      "PRICE_MORE_THAN": "Meer dan {{amount}} €",
      "PRICE_RANGE": "Tussen {{min}} € en {{max}} €",
      "PS_LOVE": "PS: ik hou van",
      "RESET_FILTERS": "Filters wissen",
      "SEARCH_KITCHEN": "Ik zoek een keuken"
    }
  },
  "ELASTIC_SEARCH": {
    "GET-CABINET-BODIES-QUERY": {
      "CABINET_BODY": "Kastcorpus"
    },
    "GET-COUNTERTOPS-QUERY": {
      "WORKTOPS": "Werkbladen"
    },
    "GET-FRONTS-QUERY": {
      "KITCHEN_FRONTS": "Fronten"
    },
    "GET-HANDLES-QUERY": {
      "HANDLES": "Grepen"
    }
  },
  "GLOBAL": {
    "AND": "En",
    "APPLIANCES_AND_SANITARY": "Toestellen en sanitair",
    "BACK": "Terug",
    "BETWEEN": "Tussen",
    "BUDGET": "Budget:",
    "CALL_TO_ACTION_CALL_US": "Bel ons",
    "CONTACT_STORE_FOR_AVAILABLE_APPOINTMENTS": "Neem contact op met {{storeName}} op <strong><a href=\"{{storePhoneTelLink}}\" style=\"white-space: nowrap;\">{{storePhoneFormatted}}</a></strong> voor de beschikbare afspraken",
    "CONTACT_STORE_FOR_AVAILABLE_APPOINTMENTS_NO_PHONE": "Neem contact op met {{storeName}} voor de beschikbare afspraken",
    "CONTACT_US": "Contacteer ons",
    "FIELD_MIN_LENGTH_ERROR": "Voer minstens 3 tekens in",
    "FINISHES": "Afwerkingen",
    "FORMS": {
      "APPOINTMENT_SERVER_ERROR": "Een afspraak maken is tijdelijk niet mogelijk. Wij raden u aan de winkel te bellen op {{phone}} of het over enkele ogenblikken opnieuw te proberen.",
      "APPOINTMENT_SERVER_ERROR_NO_PHONE": "Een afspraak maken is tijdelijk niet mogelijk. Wij raden u aan het over enkele ogenblikken opnieuw te proberen.",
      "AREA_REQUIRED_ERROR": "De regio is verplicht",
      "CALLBACK_REQUEST_PROMPT": "Wilt u teruggebeld worden?",
      "CHECKBOX_REQUIRED_ERROR": "Vink minstens één optie aan",
      "CITY_REQUIRED_ERROR": "De gemeente is verplicht",
      "EMAIL_INVALID_ERROR": "Het e-mailadres is ongeldig",
      "EMAIL_REQUIRED_ERROR": "Het e-mailadres is verplicht",
      "FIRST_NAME_MIN_LENGTH_ERROR": "De voornaam moet minstens 3 tekens bevatten",
      "GENDER_REQUIRED_ERROR": "De aanspreking is verplicht",
      "INTEREST_REQUIRED_ERROR": "De reden van uw interesse is verplicht",
      "LABEL_CITY": "Gemeente:",
      "LABEL_EMAIL": "E-mail:",
      "LABEL_FIRST_NAME": "Voornaam:",
      "LABEL_INFORMATION_TYPE": "Soort informatie:",
      "LABEL_LAST_NAME": "Naam:",
      "LABEL_MESSAGE": "Bericht:",
      "LABEL_NEWSLETTER_OPTIN": "Wilt u op de hoogte blijven van het nieuws en de aanbiedingen van SoCoo'c:",
      "LABEL_OPTIN_EMAIL": "Per e-mail",
      "LABEL_OPTIN_SMS": "Per sms",
      "LABEL_PHONE": "Telefoon:",
      "LABEL_REQUEST_TYPE": "Soort aanvraag:",
      "LABEL_STORE": "Winkel",
      "LABEL_TITLE_MADAM": "Mevrouw",
      "LABEL_TITLE_MISTER": "Meneer",
      "LABEL_ZIPCODE": "Postcode:",
      "LAST_NAME_MIN_LENGTH_ERROR": "De naam moet minstens 2 tekens bevatten",
      "MESSAGE_RECEIVED_CONFIRMATION": "Uw bericht is doorgestuurd naar onze teams, we antwoorden u zo snel mogelijk.",
      "MESSAGE_REQUIRED_ERROR": "Het bericht is verplicht",
      "PHONE_FORMAT_ERROR": "Het telefoonnummer heeft niet het juiste formaat",
      "PHONE_REQUIRED_ERROR": "Het telefoonnummer is verplicht",
      "REQUEST_INFORMATION_TYPE_REQUIRED_ERROR": "De soort informatie is verplicht",
      "REQUEST_ORDER_TYPE_REQUIRED_ERROR": "De winkel is verplicht",
      "REQUEST_TYPE_REQUIRED_ERROR": "De soort aanvraag is verplicht",
      "ZIPCODE_FORMAT_ERROR": "De postcode heeft niet het juiste formaat",
      "ZIPCODE_NOT_FOUND_ERROR": "Postcode niet herkend, voer een andere postcode in",
      "ZIPCODE_REQUIRED_ERROR": "De postcode is verplicht"
    },
    "FURNITURE": "Meubelen",
    "INCLUDING_ECO_PART": "waarvan {{price}} milieubijdrage",
    "INCLUDING_X_ENVIRONMENTAL_TAX": "waarvan {{environmentalTaxPrice}} milieubijdrage",
    "INSTALLATION_AND_DELIVERY": "Plaatsing en levering",
    "KITCHEN": "Keuken",
    "LOADING_OPENING_HOURS": "Openingsuren worden geladen",
    "LOADING_TIME_SLOTS": "Tijdsloten worden geladen",
    "NO": "Nee",
    "PUNCTUATION": {
      "COLON": ":"
    },
    "SEE_MORE": "Meer bekijken",
    "SEE_MORE_TIME_SLOTS": "Meer tijdsloten bekijken",
    "STORE_CLOSED_TODAY": "Winkel vandaag gesloten",
    "STORE_OPEN_TODAY": "Vandaag open",
    "VIEW_PRICE_DETAILS": "Prijsdetail bekijken",
    "YES": "Ja"
  },
  "MIDDLE_OFFICE": {
    "LOGOUT": "Afmelden"
  },
  "PRICE": {
    "ECO_PART": "waarvan {{ecoPart}} milieubijdrage"
  },
  "SCHEMA_JSON_LD": {
    "BLOG_MENU": "Blogmenu",
    "FOOTER_MENU": "Footermenu",
    "MAIN_MENU": "Hoofdmenu"
  }
}
